/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Finance_MonthInputs */

const en_features_finance_month = /** @type {(inputs: Features_Finance_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`October`)
};

const pl_features_finance_month = /** @type {(inputs: Features_Finance_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Październik`)
};

/**
* | output |
* | --- |
* | "October" |
*
* @param {Features_Finance_MonthInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_finance_month = /** @type {((inputs?: Features_Finance_MonthInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Finance_MonthInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_finance_month(inputs)
	return en_features_finance_month(inputs)
});